import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from "vuex-module-decorators";
import store from "@/store";

import * as api from "@/api/vuln-tracker/vulnerability";
import * as translation from "@/api/vuln-tracker/translation";
import {
  enableTranslation,
  CVETranslationResult,
  RequestPagination,
  SearchCriteriaItem,
  VulnerabilityItem,
  defaultSearchCriteria,
  duplicateSearchCriteria,
} from "@/libs/vulnUtil";
import { VulnTrackerCommonModule } from "@/store/modules/vuln-tracker/common";

@Module({
  dynamic: true,
  store,
  name: "vulnTracker.VulnerabilityRH",
  namespaced: true,
})
export class VulnerabilityRH extends VuexModule {
  itemList: VulnerabilityItem[] = [];
  total: number = 0;
  checkList: boolean[] = [];
  loading: boolean = false;
  error: string | null = null;
  title: CVETranslationResult[] = [];

  pageState: {
    currentPage: number;
    criteria: SearchCriteriaItem;
  } = {
    currentPage: 1,
    criteria: defaultSearchCriteria(),
  };

  enableTranslation: boolean = enableTranslation("vulnerabilityRH");

  @Mutation
  SetItemList(payload: VulnerabilityItem[]) {
    this.itemList = payload;
  }

  @Mutation
  SetTotal(payload: number) {
    this.total = payload;
  }

  @Mutation
  SetCheckList(payload: boolean[]) {
    this.checkList = payload;
  }

  @Mutation
  SetItemListLoading(payload: boolean) {
    this.loading = payload;
  }

  @Mutation
  SetItemListError(payload: string | null) {
    this.error = payload;
  }

  @Mutation
  SetTitle(payload: CVETranslationResult[]) {
    this.title = payload;
  }

  @Mutation
  SetCurrentPage(payload: number) {
    this.pageState.currentPage = payload;
  }

  @Mutation
  SetCriteria(payload: SearchCriteriaItem) {
    this.pageState.criteria = duplicateSearchCriteria(payload);
  }

  @Mutation
  ResetPageState() {
    this.pageState.currentPage = 1;
    this.pageState.criteria = defaultSearchCriteria();
  }

  @Mutation
  ClearItemList() {
    this.itemList = [];
  }

  @Action({ rawError: true })
  async getList(payload: { pagination: RequestPagination }) {
    this.SetItemListLoading(true);

    // 画面で入力された検索条件を複製し、redhatを固定で追加
    const criteria = duplicateSearchCriteria(this.pageState.criteria);
    criteria.redhat = true;
    await api
      .getList({
        pagination: payload.pagination,
        criteria: criteria,
      })
      .then((res) => {
        this.SetItemList(res.vulnerabilities);
        this.SetTotal(res.pagination.total);
      })
      .catch((err) => {
        this.ClearItemList();
        this.SetItemListError(err);
        VulnTrackerCommonModule.AddApiError({
          target: "脆弱性情報一覧取得(RedHat)",
          message: err,
        });
      });
    if (this.enableTranslation && this.itemList != null) {
      for (let i = 0; i < this.itemList.length; i++) {
        const vuln = this.itemList[i];
        const cveId = vuln.cve_id;
        const title = vuln.title;
        if (cveId != null && title != null) {
          const index = this.title.findIndex((result) => result.cveId == cveId);
          if (index < 0 || this.title[index].result.text != title) {
            await translation
              .translate(title)
              .then((res) => {
                if (index >= 0) {
                  this.title.splice(index, 1);
                }
                this.title.push({
                  cveId: cveId,
                  result: {
                    text: title,
                    translatedText: res.data.translations[0].translatedText,
                  },
                });
              })
              .catch((err) => {
                this.SetItemListError(err);
              });
          }
        }
      }
    }

    const checkList: boolean[] = [];
    this.itemList.forEach((vulnerability) => {
      checkList.push(vulnerability.excluded);
    });
    this.SetCheckList(checkList);

    this.SetItemListLoading(false);
  }
}

export const VulnerabilityRHModule = getModule(VulnerabilityRH);
